module.exports = __webpack_public_path__ + "static/img/1_1_3.a42b9cfc.jpg";